import type { GraphQLClient } from 'graphql-request';
import type { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** ISO 3166 Alpha 2 code */
  CountryCode: { input: any; output: any; }
  /** Datetime in ISO 8601 format. */
  ISODateString: { input: string; output: string; }
  /** Date in dd/mm/yyyy format */
  PlainDateString: { input: any; output: any; }
};

export type AddAdditionalBuyerToAuctionRegistrationInput = {
  buyer: AuctionRegistrationAdditionalBuyerInput;
  buyerId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export type AddAgencyToGroupInput = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  agencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupId: Scalars['ID']['input'];
};

export type AddIntercomTagInput = {
  agentId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type AddListingDocumentInput = {
  id: Scalars['ID']['input'];
  metadata: ListingDocumentMetadata;
  upload: FileUploadInput;
};

export type AddListingLinkInput = {
  listingId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AddMemberToBillingGroupInput = {
  agencyId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};

export type AddProfileDomainInput = {
  agencyId: Scalars['ID']['input'];
  domain: Scalars['String']['input'];
};

export type AddTrustAccountToAgencyInput = {
  agencyId: Scalars['ID']['input'];
  trustAccount: BankAccountInput;
};

export type AddUserEmailInput = {
  email: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type AddUserPhoneInput = {
  phone: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type AgencyBillingAccountAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyBillingAccountRepresentativeInput = {
  address?: InputMaybe<AgencyBillingAccountAddressInput>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyBrandingInput = {
  colors: BrandingColorsInput;
  contexts: BrandingContextsInput;
  formFooter: FooterFooterBrandingInput;
  logos: BrandingLogosInput;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AgencyBrandingToggleInput = {
  agencyId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type AgencyPaginatedListingQueryFilters = {
  /** Filter by an array of listing statuses. If omitted, all listings will be returned. */
  statuses?: InputMaybe<Array<ListingStatus>>;
};

export const AgencyStatus = {
  active: 'active',
  deactivated: 'deactivated',
  onboarding: 'onboarding'
} as const;

export type AgencyStatus = typeof AgencyStatus[keyof typeof AgencyStatus];
export type AgencyUpdateBrandingSettingsInput = {
  agencyId: Scalars['String']['input'];
  branding: AgencyBrandingInput;
};

export const AgentClaimEmailTemplateType = {
  eagle: 'eagle',
  rh_vaultre: 'rh_vaultre',
  standard: 'standard'
} as const;

export type AgentClaimEmailTemplateType = typeof AgentClaimEmailTemplateType[keyof typeof AgentClaimEmailTemplateType];
export type AgentForLjHookerCredentialsInput = {
  officeId: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
};

export type AgentHonkFeatureInput = {
  agentId: Scalars['ID']['input'];
  featureKey: Scalars['ID']['input'];
};

export const AgentInvitationStatus = {
  active: 'active',
  claimed: 'claimed',
  expired: 'expired'
} as const;

export type AgentInvitationStatus = typeof AgentInvitationStatus[keyof typeof AgentInvitationStatus];
export type AgentProfileAgencyInput = {
  location?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AgentProfileBackgroundInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  linearGradient?: InputMaybe<AgentProfileBackgroundLinearGradientInput>;
};

export type AgentProfileBackgroundLinearGradientInput = {
  angle: Scalars['Float']['input'];
  colors: Array<Scalars['String']['input']>;
  stops: Array<Scalars['Float']['input']>;
};

export type AgentProfileLayoutInput = {
  hideProppsBranding?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type AgentProfileLinkInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AgentProfileSocialsInput = {
  socialNetwork: SocialNetwork;
  url: Scalars['String']['input'];
};

export const AgentReferrer = {
  agency: 'agency',
  crm: 'crm',
  csv: 'csv',
  internal: 'internal',
  self_registration: 'self_registration',
  user: 'user'
} as const;

export type AgentReferrer = typeof AgentReferrer[keyof typeof AgentReferrer];
export const AgentRole = {
  office_admin: 'office_admin',
  sales_agent: 'sales_agent'
} as const;

export type AgentRole = typeof AgentRole[keyof typeof AgentRole];
export const AgentStatusType = {
  active: 'active',
  created: 'created',
  invited: 'invited'
} as const;

export type AgentStatusType = typeof AgentStatusType[keyof typeof AgentStatusType];
export const AnnouncementChannel = {
  email: 'email',
  sms: 'sms'
} as const;

export type AnnouncementChannel = typeof AnnouncementChannel[keyof typeof AnnouncementChannel];
export type ArchiveAllCrmIntegrationListingsInput = {
  integrationId: Scalars['ID']['input'];
};

export type AssetUploadMetadata = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  type?: InputMaybe<LogoType>;
};

export type AssignAgentToListingInput = {
  agentId: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
};

export type AssociateAgencyWithLjHookerOfficeInput = {
  agencyId: Scalars['ID']['input'];
  officeId?: InputMaybe<Scalars['ID']['input']>;
};

export type AuctionRegistrationAdditionalBuyerInput = {
  acknowledgePrimaryIsBiddingOnBehalf?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedAuctionTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address: Scalars['String']['input'];
  bidderType: BidderType;
  consentToContact?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type AuctionRegistrationInput = {
  buyerId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export type AuctionRegistrationUnauthedInput = {
  hash: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export const AuthVerificationChannel = {
  email: 'email',
  sms: 'sms'
} as const;

export type AuthVerificationChannel = typeof AuthVerificationChannel[keyof typeof AuthVerificationChannel];
export type BankAccountInput = {
  accountNo: Scalars['String']['input'];
  bsb: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export const BidderType = {
  person: 'person',
  phone: 'phone'
} as const;

export type BidderType = typeof BidderType[keyof typeof BidderType];
export type BrandingColorsInput = {
  primary?: InputMaybe<Scalars['String']['input']>;
};

export type BrandingContextsInput = {
  agency: Scalars['Boolean']['input'];
  listing: Scalars['Boolean']['input'];
  offer: Scalars['Boolean']['input'];
};

export type BrandingLogosInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
};

export type BrandingSettingsInput = {
  logoAltText?: InputMaybe<Scalars['String']['input']>;
  offerFormFooterContent?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BucketLocation = {
  bucket: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export const BulkBillingReportType = {
  eagle: 'eagle'
} as const;

export type BulkBillingReportType = typeof BulkBillingReportType[keyof typeof BulkBillingReportType];
export const BuyerVerificationStatus = {
  failed: 'failed',
  none: 'none',
  pending: 'pending',
  verified: 'verified'
} as const;

export type BuyerVerificationStatus = typeof BuyerVerificationStatus[keyof typeof BuyerVerificationStatus];
export const CrmPropertyInterestLevel = {
  /** The contact is unsure about the property */
  maybe: 'maybe',
  /** The contact is not interested in the property */
  no: 'no',
  /** The contact is interested in the property */
  yes: 'yes'
} as const;

export type CrmPropertyInterestLevel = typeof CrmPropertyInterestLevel[keyof typeof CrmPropertyInterestLevel];
export const CrmPullOperation = {
  attach_existing_agents: 'attach_existing_agents',
  attach_existing_listings: 'attach_existing_listings',
  discover_active_listings: 'discover_active_listings',
  update_existing_and_discover_recent: 'update_existing_and_discover_recent'
} as const;

export type CrmPullOperation = typeof CrmPullOperation[keyof typeof CrmPullOperation];
export type CampaignAutomationAcceptConditionalOffersConfigurationInput = {
  settings: ListingAcceptConditionalOffersInput;
  triggers: Array<Array<CampaignAutomationTriggerInput>>;
};

export type CampaignAutomationAcceptOffersConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type CampaignAutomationAuctionRegistrationConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type CampaignAutomationConfigurationInput = {
  acceptOffers?: InputMaybe<CampaignAutomationAcceptOffersConfigurationInput>;
  auctionRegistration?: InputMaybe<CampaignAutomationAuctionRegistrationConfigurationInput>;
  idv?: InputMaybe<CampaignAutomationIdvConfigurationInput>;
  listingTactics: CampaignAutomationListingTacticsConfigurationInput;
  priceFeedback?: InputMaybe<CampaignAutomationPriceFeedbackConfigurationInput>;
  proppsButtonLabel?: InputMaybe<Scalars['String']['input']>;
  quickOffer?: InputMaybe<CampaignAutomationQuickOfferConfigurationInput>;
};

export const CampaignAutomationConfigurationType = {
  auction: 'auction',
  private_treaty: 'private_treaty'
} as const;

export type CampaignAutomationConfigurationType = typeof CampaignAutomationConfigurationType[keyof typeof CampaignAutomationConfigurationType];
export type CampaignAutomationCountdownTimerConfigurationInput = {
  settings: CountdownTimerInput;
  triggers: Array<Array<CampaignAutomationTriggerInput>>;
};

export type CampaignAutomationExposeCompetitionConfigurationInput = {
  settings: ListingExposeCompetitionInput;
  triggers: Array<Array<CampaignAutomationTriggerInput>>;
};

export type CampaignAutomationExposeInsightsConfigurationInput = {
  settings: ListingExposeInsightsInput;
  triggers: Array<Array<CampaignAutomationTriggerInput>>;
};

export type CampaignAutomationIdvConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type CampaignAutomationListingTacticsConfigurationInput = {
  acceptConditionalOffers?: InputMaybe<CampaignAutomationAcceptConditionalOffersConfigurationInput>;
  countdownTimer?: InputMaybe<CampaignAutomationCountdownTimerConfigurationInput>;
  exposeCompetition?: InputMaybe<CampaignAutomationExposeCompetitionConfigurationInput>;
  exposeInsights?: InputMaybe<CampaignAutomationExposeInsightsConfigurationInput>;
  newOfferNotifications?: InputMaybe<CampaignAutomationNewOfferNotificationsConfigurationInput>;
};

export type CampaignAutomationNewOfferNotificationsConfigurationInput = {
  settings: ListingBuyerNewOfferNotificationsInput;
  triggers: Array<Array<CampaignAutomationTriggerInput>>;
};

export type CampaignAutomationPriceFeedbackConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type CampaignAutomationQuickOfferConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export const CampaignAutomationTriggerField = {
  buyers: 'buyers',
  offers: 'offers',
  time: 'time'
} as const;

export type CampaignAutomationTriggerField = typeof CampaignAutomationTriggerField[keyof typeof CampaignAutomationTriggerField];
export type CampaignAutomationTriggerInput = {
  field: CampaignAutomationTriggerField;
  operator: CampaignAutomationTriggerOperator;
  value: Scalars['Int']['input'];
};

export const CampaignAutomationTriggerOperator = {
  eq: 'eq',
  gte: 'gte'
} as const;

export type CampaignAutomationTriggerOperator = typeof CampaignAutomationTriggerOperator[keyof typeof CampaignAutomationTriggerOperator];
export const CampaignOptimizerPlanEnum = {
  all: 'all',
  individual: 'individual'
} as const;

export type CampaignOptimizerPlanEnum = typeof CampaignOptimizerPlanEnum[keyof typeof CampaignOptimizerPlanEnum];
export type ChangeUserPhoneInput = {
  verificationCode: Scalars['String']['input'];
  verificationId: Scalars['String']['input'];
};

export type CheckDomainAvailabilityInput = {
  agentId: Scalars['String']['input'];
  domain: Scalars['String']['input'];
};

export type ClaimAgentInvitationInput = {
  claimKey: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type ClaimLiteOfferInput = {
  buyerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type ClaimSsoTokenInput = {
  token: Scalars['String']['input'];
};

export const ClaimSsoTokenStatus = {
  sso_ready: 'sso_ready',
  user_link_required: 'user_link_required',
  user_setup_required: 'user_setup_required'
} as const;

export type ClaimSsoTokenStatus = typeof ClaimSsoTokenStatus[keyof typeof ClaimSsoTokenStatus];
export type ClearAgentPhoneInput = {
  agentId: Scalars['ID']['input'];
};

export type ClearAgentProfileImageInput = {
  id: Scalars['ID']['input'];
};

export type CompleteProfileSessionContactInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CompletedAuthorityToBidDocumentInput = {
  metadata: FileMetadata;
  upload: FileUploadInput;
};

export type ConditionRevisionInput = {
  id: Scalars['String']['input'];
  line: Scalars['String']['input'];
  params: Array<ConditionRevisionParameterInput>;
  region: Scalars['String']['input'];
};

export type ConditionRevisionParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ConnectAgentToAgencyInput = {
  agencyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** connectDeveloperAppToAgency mutation input */
export type ConnectDeveloperAppToAgencyInput = {
  agencyId: Scalars['ID']['input'];
  developerAppId: Scalars['ID']['input'];
};

export type ConsolidateBillingGroupInvoicesInput = {
  from: Scalars['ISODateString']['input'];
  groupId: Scalars['ID']['input'];
  to: Scalars['ISODateString']['input'];
};

export const ConsolidatedInvoiceStatus = {
  draft: 'draft',
  paid: 'paid',
  sent: 'sent',
  void: 'void'
} as const;

export type ConsolidatedInvoiceStatus = typeof ConsolidatedInvoiceStatus[keyof typeof ConsolidatedInvoiceStatus];
export type ConveyancerInformationInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: ConveyancerInformationInputType;
};

export const ConveyancerInformationInputType = {
  need_conveyancer_help: 'need_conveyancer_help',
  need_legal_process_help: 'need_legal_process_help',
  none: 'none',
  not_provided: 'not_provided',
  provided: 'provided'
} as const;

export type ConveyancerInformationInputType = typeof ConveyancerInformationInputType[keyof typeof ConveyancerInformationInputType];
export type CountdownTimerInput = {
  announcementBody?: InputMaybe<Scalars['String']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiryDateHour?: InputMaybe<Scalars['Int']['input']>;
  expiryDateMinute?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  notifyBuyersBeforeExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  pauseListingOnExpiry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAgencyGroupInput = {
  category: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

/** createAgency mutation input */
export type CreateAgencyInput = {
  /** ISO 3166 Alpha 2 code, supports only AU or NZ */
  country?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateAgentBoxCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByOffice?: InputMaybe<Scalars['String']['input']>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAgentCorrelationOnIntegrationInput = {
  crmId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  proppsId: Scalars['String']['input'];
};

/** createAgent mutation input */
export type CreateAgentInput = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<AgentReferrer>;
};

export type CreateAgentPodInput = {
  agencyId: Scalars['ID']['input'];
  /** Agent IDs that will be inheriting permissions from the targets */
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Agent IDs that members of the pod will inherit permissions from */
  targets?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateAgentTokenInput = {
  agentId: Scalars['ID']['input'];
  uid: Scalars['ID']['input'];
};

export type CreateBestAndFinalNoticeInput = {
  agentId: Scalars['String']['input'];
  /** If specified, creates an announcement with the same message to notify buyers */
  buyerIds: Array<Scalars['String']['input']>;
  expiry: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  /** If specified, creates an announcement with the same message to notify CRM property interests */
  propertyInterestIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateBillingGroupInput = {
  name: Scalars['String']['input'];
  stripeCustomerId: Scalars['String']['input'];
};

export type CreateBoxDiceCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterOfficeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
  subdomain: Scalars['String']['input'];
};

export type CreateBoxDiceInstanceInput = {
  apiKey: Scalars['String']['input'];
  endpoint?: InputMaybe<Scalars['String']['input']>;
  subdomain: Scalars['String']['input'];
};

/** createBuyer mutation input */
export type CreateBuyerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCustomNoticeInput = {
  agentId: Scalars['String']['input'];
  /** If specified, creates an announcement with the same message to notify buyers */
  buyerIds: Array<Scalars['String']['input']>;
  /** Supports 'sms' and 'email' as channels for announcement */
  channels: Array<Scalars['String']['input']>;
  listingId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  /** If specified, creates an announcement with the same message to notify CRM property interests */
  propertyInterestIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** createDeveloperApp mutation input */
export type CreateDeveloperAppInput = {
  name: Scalars['String']['input'];
};

export type CreateEagleCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings: Scalars['Boolean']['input'];
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateFlkItOverDocumentInput = {
  offerId: Scalars['ID']['input'];
  vendorEmail: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
};

export type CreateIncompleteListingAgentDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIntercomLeadInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateListingFeedbackFeedbackInput = {
  interest?: InputMaybe<Scalars['String']['input']>;
  worth?: InputMaybe<ListingFeedbackWorthInput>;
};

export type CreateListingFeedbackInput = {
  buyerId: Scalars['ID']['input'];
  feedback: CreateListingFeedbackFeedbackInput;
  listingId: Scalars['ID']['input'];
};

export type CreateListingInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>;
  agentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Listing identifiers is no longer used */
  identifiers?: InputMaybe<Array<ListingIdentifierInput>>;
  listingType?: InputMaybe<ListingType>;
  priceIndication: ListingPriceIndicationInput;
  property: PropertyInput;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  source: ListingCreateSourceInput;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLiteOfferInput = {
  /** Additional comments only visible to the agent. */
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  /** Agent to send the invitation on behalf of. If omitted, sends it on behalf of the primary listing agent. */
  agentId?: InputMaybe<Scalars['String']['input']>;
  /** Offer amount to pre-fill the offer form with. If omitted, does not pre-fill the offer amount. */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** The contact details of the buyer to include in the invitation and pre-fill details with. */
  buyerContact: LiteOfferBuyerContactInput;
  /** The optional condiitions for the offer. Will not prefill the offer form. */
  conditions?: InputMaybe<LiteOfferConditionsInput>;
  /** Whether to send the offer invitation to the buyer as an email. */
  inviteBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['String']['input'];
  /** The purchase deposit to pre-fill the offer form with. If omitted, does not pre-fill the purchase deposit. */
  purchaseDeposit?: InputMaybe<LiteOfferPurchaseDepositInput>;
  /** The settlement to pre-fill the offer form with. If omitted, does not pre-fill the settlement. */
  settlement?: InputMaybe<LiteOfferSettlementInput>;
};

export type CreateLockedOnCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};

export type CreateMoveCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  instance: Scalars['String']['input'];
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  officeId: Scalars['ID']['input'];
  pullAuctionListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateNoticeInput = {
  agentId: Scalars['String']['input'];
  /** If specified, creates an announcement with the same message to notify buyers */
  buyerIds: Array<Scalars['String']['input']>;
  listingId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  /** If specified, creates an announcement with the same message to notify CRM property interests */
  propertyInterestIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOfferUpdateRequestInput = {
  buyerId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  offer: UpdateOfferRequestOfferInput;
  offerId: Scalars['String']['input'];
};

export type CreatePlanUpgradeCheckoutSessionInput = {
  agentId: Scalars['ID']['input'];
  billingPeriod: PlanUpgradeBillingPeriod;
};

export type CreateProfileDomainCheckoutSessionInput = {
  agentId: Scalars['ID']['input'];
  domain: Scalars['String']['input'];
  /** BUSINESS_CARD_BASIC or BUSINESS_CARD_PRO */
  plan: Scalars['String']['input'];
};

export type CreateProfileSessionInput = {
  agentId: Scalars['ID']['input'];
  data: ProfileSessionDataInput;
};

export type CreateRexcrmIntegrationInput = {
  accountId: Scalars['ID']['input'];
  agencyId: Scalars['ID']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings: Scalars['Boolean']['input'];
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
  r2Prefix: Scalars['Boolean']['input'];
};

export type CreateReferralClaimInput = {
  email: Scalars['String']['input'];
  referralId: Scalars['ID']['input'];
};

export type CreateReferralInput = {
  code: Scalars['String']['input'];
  referrerId: Scalars['ID']['input'];
};

export type CreateRtaIntegrationInput = {
  agencyId: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
};

export type CreateSuperadminInput = {
  name: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type CreateVaultreCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  apiToken: Scalars['String']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterByTeam?: InputMaybe<Scalars['ID']['input']>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings: Scalars['Boolean']['input'];
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateWebhookInput = {
  appId: Scalars['String']['input'];
  filters: WebhookEventFiltersInput;
  sources: Array<WebhookEventSourceInput>;
  url: Scalars['String']['input'];
};

export type CreateZenuCrmIntegrationInput = {
  agencyId: Scalars['ID']['input'];
  authId: Scalars['String']['input'];
  authToken: Scalars['String']['input'];
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  pullAuctionListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullPrivateTreatyListings?: InputMaybe<Scalars['Boolean']['input']>;
  pullResidentialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrmInstanceAgentboxInput = {
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};

export type CrmInstanceBoxdiceInput = {
  instanceId: Scalars['ID']['input'];
};

export type CrmInstanceInput = {
  agentbox?: InputMaybe<CrmInstanceAgentboxInput>;
  boxdice?: InputMaybe<CrmInstanceBoxdiceInput>;
  lockedon?: InputMaybe<CrmInstanceLockedonInput>;
};

export type CrmInstanceLockedonInput = {
  token: Scalars['String']['input'];
};

export const DefaultListingStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  ENABLED: 'ENABLED'
} as const;

export type DefaultListingStatus = typeof DefaultListingStatus[keyof typeof DefaultListingStatus];
export const DefaultOfferFormType = {
  nonbinding: 'nonbinding',
  quick: 'quick'
} as const;

export type DefaultOfferFormType = typeof DefaultOfferFormType[keyof typeof DefaultOfferFormType];
export type DeleteLiteOfferInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRtaIntegrationInput = {
  agencyId: Scalars['String']['input'];
};

export const DepositPercentage = {
  five: 'five',
  other: 'other',
  tbd: 'tbd',
  ten: 'ten'
} as const;

export type DepositPercentage = typeof DepositPercentage[keyof typeof DepositPercentage];
export type DeveloperAppBrandingInput = {
  colors: BrandingColorsInput;
  contexts: BrandingContextsInput;
  formFooter: FooterFooterBrandingInput;
  logos: BrandingLogosInput;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DeveloperAppBrandingToggleInput = {
  appId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export const DeveloperAppResolutionMode = {
  barry_plant: 'barry_plant',
  crm_integration: 'crm_integration',
  default: 'default'
} as const;

export type DeveloperAppResolutionMode = typeof DeveloperAppResolutionMode[keyof typeof DeveloperAppResolutionMode];
export type DeveloperAppUpdateBrandingSettingsInput = {
  appId: Scalars['String']['input'];
  branding: DeveloperAppBrandingInput;
};

export type DisableWebhookInput = {
  appId: Scalars['String']['input'];
  webhookId: Scalars['ID']['input'];
};

export type DisconnectAgentFromAgencyInput = {
  agencyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DismissListingCampaignRecommendationInput = {
  listingId: Scalars['ID']['input'];
  recommendationId: Scalars['ID']['input'];
};

export type DispatchListingCampaignAssetNotificationsForAgencyInput = {
  agencyId: Scalars['ID']['input'];
};

export type DocumentRevisionInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type DraftOfferSignatoryInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agreeToIdentityVerification?: InputMaybe<Scalars['Boolean']['input']>;
  agreedContractRevision?: InputMaybe<DocumentRevisionInput>;
  agreedTermsRevision?: InputMaybe<TermsRevisionInput>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  isPrimaryBuyer: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  onBehalfOf?: InputMaybe<RepresentedEntityInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Enable agency wide offer boost (admin use) */
export type EnableAgencyWideOfferBoostInput = {
  agencyId: Scalars['String']['input'];
};

export type FileMetadata = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type FileUploadInput = {
  bucket: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type FinanceDeclarationInput = {
  date?: InputMaybe<Scalars['PlainDateString']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FinanceDeclarationInputType>;
};

export const FinanceDeclarationInputType = {
  approved: 'approved',
  none: 'none',
  not_applicable: 'not_applicable',
  not_provided: 'not_provided',
  other: 'other'
} as const;

export type FinanceDeclarationInputType = typeof FinanceDeclarationInputType[keyof typeof FinanceDeclarationInputType];
export const FlkItOverDocumentStatus = {
  active: 'active',
  awaiting_completion: 'awaiting_completion',
  complete: 'complete',
  draft: 'draft',
  sent_for_signing: 'sent_for_signing'
} as const;

export type FlkItOverDocumentStatus = typeof FlkItOverDocumentStatus[keyof typeof FlkItOverDocumentStatus];
export type FooterFooterBrandingInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type ForwardOfferToVendorInput = {
  agentId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  offerId: Scalars['ID']['input'];
  /** @deprecated Use vendors instead */
  vendor?: InputMaybe<VendorInput>;
  vendors?: InputMaybe<Array<VendorInput>>;
};

export type FullNameInput = {
  /** Family name */
  family: Scalars['String']['input'];
  /** Given name (s) */
  given: Scalars['String']['input'];
  /** Middle name(s) */
  middle: Scalars['String']['input'];
};

export type GenerateAgentCardDesignBackInput = {
  email: GenerateAgentCardDesignEmailInput;
  logo: GenerateAgentCardDesignLogoInput;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GenerateAgentCardDesignEmailInput = {
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type GenerateAgentCardDesignFrontInput = {
  backgroundColor: Scalars['String']['input'];
  logo: GenerateAgentCardDesignLogoInput;
};

export type GenerateAgentCardDesignInput = {
  back: GenerateAgentCardDesignBackInput;
  cardId: Scalars['ID']['input'];
  front: GenerateAgentCardDesignFrontInput;
  templateVersion?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAgentCardDesignLogoInput = {
  offsetY?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

export type GenerateBillingGroupInvoiceReportInput = {
  consolidatedInvoiceId: Scalars['ID']['input'];
  reportType: BulkBillingReportType;
};

export type GenerateBillingGroupStripeInvoiceInput = {
  consolidatedInvoiceId: Scalars['ID']['input'];
};

export type GenerateEmailSignatureInput = {
  agentId: Scalars['ID']['input'];
  /** Where the email footer will be sent to. If omitted, will be sent to the email of the agent with the given ID. */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateLjHookerOAuthRedirectUrlInput = {
  state?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateNfcCardCheckoutPageInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>;
  agencyName?: InputMaybe<Scalars['String']['input']>;
  agencyRegion?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
  callbackUrl: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type GeneratePreauthedWebappLinkInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type GenericOfferConditions = {
  other?: InputMaybe<Scalars['String']['input']>;
  subjectToBuildingInspection: Scalars['Boolean']['input'];
  subjectToFinance: Scalars['Boolean']['input'];
  subjectToPestInspection: Scalars['Boolean']['input'];
};

export type GetAgencyNameInput = {
  agencyId: Scalars['ID']['input'];
};

export type HandleLjHookerOAuthCallbackInput = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export const HoldingDepositStatus = {
  received: 'received',
  refunded: 'refunded',
  submitted: 'submitted',
  unpaid: 'unpaid'
} as const;

export type HoldingDepositStatus = typeof HoldingDepositStatus[keyof typeof HoldingDepositStatus];
export type IdentityDocument2Input = {
  /** ISO-3166-alpha3 country code */
  country: Scalars['String']['input'];
  /** The issue number of the document (eg. card no. on drivers license */
  issueNo?: InputMaybe<Scalars['String']['input']>;
  /** The license or passport number */
  number: Scalars['String']['input'];
  /** Regional variant of ID depending on document type, eg. state abrreviation (VIC) for DRIVERS_LICENCE */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The type of id document to verify. DRIVERS_LICENCE or PASSPORT */
  type: Scalars['String']['input'];
};

export type IdentityDocumentInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  documentNo: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  type: IdentityDocumentType;
};

export const IdentityDocumentType = {
  drivers_licence: 'drivers_licence',
  passport: 'passport'
} as const;

export type IdentityDocumentType = typeof IdentityDocumentType[keyof typeof IdentityDocumentType];
export type ImportListingsCsvInput = {
  agencyId: Scalars['ID']['input'];
  appId: Scalars['ID']['input'];
  csv: Scalars['String']['input'];
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IsAllowedOriginForDeveloperAppInput = {
  appId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type IssueFrankieSmartUiSessionCreateDataInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type IssueFrankieSmartUiSessionInput = {
  /** Whether to allow passport as a verification method. Defaults to true. */
  allowPassport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Data to create a frankie entity if provided ID does not already exist. If not provided, the entity must already exist. */
  createData?: InputMaybe<IssueFrankieSmartUiSessionCreateDataInput>;
  referenceId: Scalars['ID']['input'];
};

export type IssueReferralInput = {
  referrerId: Scalars['ID']['input'];
};

export type LinkSsoUserInput = {
  token: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type ListingAcceptConditionalOffersInput = {
  enabled: Scalars['Boolean']['input'];
};

export type ListingActivityFilters = {
  buyerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListingAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type ListingBuyerNewOfferNotificationsInput = {
  enabled: Scalars['Boolean']['input'];
};

export type ListingCreateSourceInput = {
  appId: Scalars['String']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type ListingDocumentMetadata = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: ListingDocumentType;
};

export type ListingDocumentRef = {
  filename?: InputMaybe<Scalars['String']['input']>;
  name: ListingDocumentType;
};

export const ListingDocumentType = {
  COS: 'COS',
  auctionTerms: 'auctionTerms',
  authorityToBid: 'authorityToBid',
  biddersGuide: 'biddersGuide',
  custom: 'custom',
  sec32: 'sec32'
} as const;

export type ListingDocumentType = typeof ListingDocumentType[keyof typeof ListingDocumentType];
export type ListingDocumentsInput = {
  /** Fetch all viewable documents along with their previous versions */
  fetchAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include hidden documents in result */
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListingExposeCompetitionInput = {
  state: ListingExposeCompetitionState;
};

/** Listing expose competition settings */
export const ListingExposeCompetitionState = {
  HIDDEN: 'HIDDEN',
  OFFER_INFO: 'OFFER_INFO',
  POSITION: 'POSITION'
} as const;

export type ListingExposeCompetitionState = typeof ListingExposeCompetitionState[keyof typeof ListingExposeCompetitionState];
export type ListingExposeInsightsInput = {
  enabled: Scalars['Boolean']['input'];
};

export type ListingFeatureToggleInput = {
  enable: Scalars['Boolean']['input'];
  flag: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ListingFeedbackInput = {
  buyerId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export const ListingFeedbackInterest = {
  kind_of: 'kind_of',
  not_really: 'not_really',
  very: 'very'
} as const;

export type ListingFeedbackInterest = typeof ListingFeedbackInterest[keyof typeof ListingFeedbackInterest];
export type ListingFeedbackWorthInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type ListingIdentifierInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ListingNewOfferNotificationsInput = {
  enabled: Scalars['Boolean']['input'];
};

export type ListingOfferBoostInput = {
  enabled: Scalars['Boolean']['input'];
};

export const ListingOfferBoostStatus = {
  active: 'active',
  locked: 'locked',
  ready: 'ready'
} as const;

export type ListingOfferBoostStatus = typeof ListingOfferBoostStatus[keyof typeof ListingOfferBoostStatus];
export type ListingPermalinkInput = {
  shortUrl: Scalars['Boolean']['input'];
  trackingContext: ListingPermalinkTrackingContext;
};

export const ListingPermalinkTrackingContext = {
  APP_SHARE_LINK: 'APP_SHARE_LINK',
  APP_SHARE_QR: 'APP_SHARE_QR',
  GENERIC: 'GENERIC'
} as const;

export type ListingPermalinkTrackingContext = typeof ListingPermalinkTrackingContext[keyof typeof ListingPermalinkTrackingContext];
export type ListingPriceIndicationInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  type: ListingPriceIndicationType;
};

export const ListingPriceIndicationType = {
  custom: 'custom',
  min: 'min',
  range: 'range'
} as const;

export type ListingPriceIndicationType = typeof ListingPriceIndicationType[keyof typeof ListingPriceIndicationType];
export type ListingSourceInput = {
  appId: Scalars['String']['input'];
  foreignId: Scalars['String']['input'];
};

export const ListingStatus = {
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  ENABLED: 'ENABLED',
  PAUSED: 'PAUSED',
  SOLD: 'SOLD',
  UNDER_OFFER: 'UNDER_OFFER'
} as const;

export type ListingStatus = typeof ListingStatus[keyof typeof ListingStatus];
export const ListingType = {
  demo: 'demo',
  native: 'native',
  referred: 'referred',
  test: 'test'
} as const;

export type ListingType = typeof ListingType[keyof typeof ListingType];
export type LiteOfferBuyerContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type LiteOfferConditionsInput = {
  other?: InputMaybe<Scalars['String']['input']>;
  subjectToBuildingInspection: Scalars['Boolean']['input'];
  subjectToFinance: Scalars['Boolean']['input'];
  subjectToPestInspection: Scalars['Boolean']['input'];
};

export type LiteOfferFilters = {
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LiteOfferPurchaseDepositInput = {
  type: LiteOfferPurchaseDepositType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export const LiteOfferPurchaseDepositType = {
  amount: 'amount',
  percentage: 'percentage',
  tbd: 'tbd'
} as const;

export type LiteOfferPurchaseDepositType = typeof LiteOfferPurchaseDepositType[keyof typeof LiteOfferPurchaseDepositType];
export type LiteOfferSettlementInput = {
  type: LiteOfferSettlementType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export const LiteOfferSettlementType = {
  date: 'date',
  days: 'days',
  tbd: 'tbd'
} as const;

export type LiteOfferSettlementType = typeof LiteOfferSettlementType[keyof typeof LiteOfferSettlementType];
/** Lock offer boost (admin use) */
export type LockOfferBoostInput = {
  listingId: Scalars['String']['input'];
};

export const LogoType = {
  black: 'black',
  color: 'color',
  white: 'white'
} as const;

export type LogoType = typeof LogoType[keyof typeof LogoType];
export const MethodOfSale = {
  AUCTION: 'AUCTION',
  PRIVATE_TREATY: 'PRIVATE_TREATY'
} as const;

export type MethodOfSale = typeof MethodOfSale[keyof typeof MethodOfSale];
export type ModifyAgencyAnnouncementTemplateInput = {
  agencyId: Scalars['String']['input'];
  data: ModifyAnnouncementTemplateInput;
};

export type ModifyAgentAnnouncementTemplateInput = {
  agentId: Scalars['String']['input'];
  data: ModifyAnnouncementTemplateInput;
};

export type ModifyAnnouncementTemplateInput = {
  /** Leave empty for a create operation, include for update, or delete operation */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Leave empty for a delete operation, include for update, or create operation */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Leave empty for a delete operation, include for update, or create operation */
  template?: InputMaybe<Scalars['String']['input']>;
};

export type ModifyPolicyParentInput = {
  childId: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type ModifyProfileDomainAgenciesInput = {
  agencyId: Scalars['ID']['input'];
  domainId: Scalars['ID']['input'];
};

export const NominalOfferAgreementType = {
  digital_signature_consent: 'digital_signature_consent',
  identity_verification: 'identity_verification'
} as const;

export type NominalOfferAgreementType = typeof NominalOfferAgreementType[keyof typeof NominalOfferAgreementType];
export type NotificationPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type OfferAgentInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export const OfferAttachmentType = {
  contract: 'contract',
  receipt: 'receipt'
} as const;

export type OfferAttachmentType = typeof OfferAttachmentType[keyof typeof OfferAttachmentType];
/** Update offerboost agent list */
export type OfferBoostAgentConfig = {
  agentId: Scalars['String']['input'];
  includeAuctionListings: Scalars['Boolean']['input'];
  includeCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export const OfferBoostPriceTier = {
  all: 'all',
  individual: 'individual'
} as const;

export type OfferBoostPriceTier = typeof OfferBoostPriceTier[keyof typeof OfferBoostPriceTier];
export const OfferConditionRevisionInputType = {
  dollar: 'dollar',
  number: 'number',
  text: 'text'
} as const;

export type OfferConditionRevisionInputType = typeof OfferConditionRevisionInputType[keyof typeof OfferConditionRevisionInputType];
export const OfferConditionRevisionParamsType = {
  amount: 'amount',
  dateText: 'dateText',
  select: 'select'
} as const;

export type OfferConditionRevisionParamsType = typeof OfferConditionRevisionParamsType[keyof typeof OfferConditionRevisionParamsType];
export type OfferFeedbackInput = {
  buyerName: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  feeling?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferFormFeedbackInput = {
  buyerName: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  feeling?: InputMaybe<Scalars['Int']['input']>;
};

export const OfferFormType = {
  binding: 'binding',
  nonbinding: 'nonbinding',
  quick: 'quick'
} as const;

export type OfferFormType = typeof OfferFormType[keyof typeof OfferFormType];
export type OfferPropertyInput = {
  address: AddressInput;
};

export type OfferSettlementInput = {
  date?: InputMaybe<Scalars['PlainDateString']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  type: OfferSettlementPeriodType;
};

export const OfferSettlementPeriodType = {
  date: 'date',
  days: 'days',
  default: 'default'
} as const;

export type OfferSettlementPeriodType = typeof OfferSettlementPeriodType[keyof typeof OfferSettlementPeriodType];
export type OfferSignatoryInput = {
  address: Scalars['String']['input'];
  agreeToIdentityVerification?: InputMaybe<Scalars['Boolean']['input']>;
  agreedContractRevision?: InputMaybe<DocumentRevisionInput>;
  agreedPrivacyPolicyRevision?: InputMaybe<TermsRevisionInput>;
  agreedTermsRevision?: InputMaybe<TermsRevisionInput>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated no longer accepted */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityDocument?: InputMaybe<IdentityDocumentInput>;
  isPrimaryBuyer: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  onBehalfOf: RepresentedEntityInput;
  phone: Scalars['String']['input'];
  /** Base64 encoded png of signature image */
  signatureData?: InputMaybe<Scalars['String']['input']>;
};

export const OfferStatus = {
  active: 'active',
  expired: 'expired',
  withdrawn: 'withdrawn'
} as const;

export type OfferStatus = typeof OfferStatus[keyof typeof OfferStatus];
export const OfferType = {
  binding: 'binding',
  nonbinding: 'nonbinding'
} as const;

export type OfferType = typeof OfferType[keyof typeof OfferType];
export const OfferUpdateRequestState = {
  pending: 'pending',
  rejected: 'rejected'
} as const;

export type OfferUpdateRequestState = typeof OfferUpdateRequestState[keyof typeof OfferUpdateRequestState];
export type PaginatedListingQueryFilters = {
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by an array of listing statuses. If omitted, all listings will be returned. */
  statuses?: InputMaybe<Array<ListingStatus>>;
};

export type PermissionStateInput = {
  granted: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};

export const PlanUpgradeBillingPeriod = {
  monthly: 'monthly',
  yearly: 'yearly'
} as const;

export type PlanUpgradeBillingPeriod = typeof PlanUpgradeBillingPeriod[keyof typeof PlanUpgradeBillingPeriod];
export type ProfileEditLinkInput = {
  actionLabel?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<ProfileEditLinkInputPrice>;
  reviewerName?: InputMaybe<Scalars['String']['input']>;
  reviewerRole?: InputMaybe<Scalars['String']['input']>;
  testimony?: InputMaybe<Scalars['String']['input']>;
  type: ProfileEditLinkType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileEditLinkInputPrice = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export const ProfileEditLinkType = {
  APPRAISAL_FORM: 'APPRAISAL_FORM',
  CALL: 'CALL',
  EMAIL: 'EMAIL',
  HYPERLINK: 'HYPERLINK',
  IMAGE: 'IMAGE',
  OFFER_FORM: 'OFFER_FORM',
  PRODUCT_SERVICE: 'PRODUCT_SERVICE',
  SAVE_CONTACT: 'SAVE_CONTACT',
  SMS: 'SMS',
  TESTIMONIAL: 'TESTIMONIAL',
  VIMEO: 'VIMEO',
  YOUTUBE: 'YOUTUBE'
} as const;

export type ProfileEditLinkType = typeof ProfileEditLinkType[keyof typeof ProfileEditLinkType];
export type ProfileSessionContactInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileSessionContextDestinationInput = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ProfileSessionContextInput = {
  destination?: InputMaybe<ProfileSessionContextDestinationInput>;
};

export type ProfileSessionDataInput = {
  contact?: InputMaybe<ProfileSessionContactInput>;
  context?: InputMaybe<ProfileSessionContextInput>;
  geoLocation?: InputMaybe<ProfileSessionGeoLocationInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfileSessionEventInput = {
  click?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileSessionGeoLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type PropertyInput = {
  address: ListingAddressInput;
};

export const PropertyType = {
  commercial: 'commercial',
  residential: 'residential'
} as const;

export type PropertyType = typeof PropertyType[keyof typeof PropertyType];
export type ProppsCardContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export const ProppsProductName = {
  AGENT_PLUS: 'AGENT_PLUS',
  OFFERS_PLUS: 'OFFERS_PLUS',
  OFFICE_PLUS: 'OFFICE_PLUS',
  PROPPS_PLUS: 'PROPPS_PLUS',
  UNKNOWN: 'UNKNOWN'
} as const;

export type ProppsProductName = typeof ProppsProductName[keyof typeof ProppsProductName];
export type ProvisionDeveloperAppApiKeyInput = {
  appId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProvisionNfcCardInput = {
  agentIds: Array<Scalars['ID']['input']>;
  cardDesignId: Scalars['ID']['input'];
  templateVersion?: InputMaybe<Scalars['String']['input']>;
};

export type ProxyForInput = {
  acknowledgePrimaryIsBiddingOnBehalf?: InputMaybe<Scalars['Boolean']['input']>;
  acknowledgedAuctionTerms?: InputMaybe<Scalars['Boolean']['input']>;
  address: Scalars['String']['input'];
  bidderType?: InputMaybe<BidderType>;
  consentToContact?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PushNotificationTokenInput = {
  agentId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type QueryAgentBoxAgentsInput = {
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};

export type QueryAgentBoxOfficesInput = {
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};

export type QueryEagleAgentsInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type QueryMoveAgentsInput = {
  instance?: InputMaybe<Scalars['String']['input']>;
  officeId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMoveOfficesInput = {
  instance?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRexAgentsByAccountIdInput = {
  id: Scalars['ID']['input'];
};

export type QueryVaultreAgentsInput = {
  token: Scalars['String']['input'];
};

export type QueryVaultreTeamsInput = {
  token: Scalars['String']['input'];
};

export type QueryZenuAgentsInput = {
  authId: Scalars['String']['input'];
  authToken: Scalars['String']['input'];
};

export type RegisterAgentAccountAgencyInput = {
  country: Scalars['CountryCode']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  teamSize?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterAgentProfileInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterBuyerOnListingInput = {
  buyerId: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
};

export type RegisterForAuctionInput = {
  acknowledgedAuctionTerms?: InputMaybe<Scalars['Boolean']['input']>;
  bidderType?: InputMaybe<BidderType>;
  buyerAddress?: InputMaybe<Scalars['String']['input']>;
  buyerId: Scalars['ID']['input'];
  completedAuthorityToBidDocument?: InputMaybe<CompletedAuthorityToBidDocumentInput>;
  consentToContact?: InputMaybe<Scalars['Boolean']['input']>;
  isProxyBidder?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['ID']['input'];
  onBehalfOf?: InputMaybe<Scalars['String']['input']>;
  proxyFor?: InputMaybe<ProxyForInput>;
};

export type RemoveAdditionalBuyerFromAuctionRegistration = {
  additionalBuyerId: Scalars['ID']['input'];
  buyerId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export type RemoveAgencyFromGroupInput = {
  agencyId: Scalars['ID']['input'];
  groupId: Scalars['ID']['input'];
};

export type RemoveAgentFromListingInput = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  agentId: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
};

export type RemoveIntercomTagInput = {
  agentId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type RemoveListingLinkInput = {
  linkId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export type RemoveProfileDomainInput = {
  domainId: Scalars['ID']['input'];
};

export type RemoveUserEmailInput = {
  email: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type RemoveUserPhoneInput = {
  uid: Scalars['ID']['input'];
};

export type RepresentedEntityInput = {
  abnAcn?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: RepresentedEntityInputType;
};

export const RepresentedEntityInputType = {
  company: 'company',
  person: 'person',
  self: 'self'
} as const;

export type RepresentedEntityInputType = typeof RepresentedEntityInputType[keyof typeof RepresentedEntityInputType];
export type RequestAccountDeletionInput = {
  agentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RequestCrmIntegrationInput = {
  agentId: Scalars['ID']['input'];
  crm: Scalars['String']['input'];
  crmOther?: InputMaybe<Scalars['String']['input']>;
};

export type RequestNfcCardsInput = {
  agentId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
};

export type RequestOfferBoostHelpInput = {
  agentId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export type ResolveReferredListingInput = {
  agentDetails: Array<CreateIncompleteListingAgentDetailsInput>;
  agentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Listing identifiers is no longer used */
  identifiers?: InputMaybe<Array<ListingIdentifierInput>>;
  listingType?: InputMaybe<ListingType>;
  priceIndication: ListingPriceIndicationInput;
  property: PropertyInput;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  source: ListingSourceInput;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeUserRoleInput = {
  role: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export const RtaActivationStatus = {
  contract_ready: 'contract_ready',
  no_contract: 'no_contract',
  not_linked: 'not_linked'
} as const;

export type RtaActivationStatus = typeof RtaActivationStatus[keyof typeof RtaActivationStatus];
export const RtaOfferStatus = {
  contract_ready: 'contract_ready',
  no_contract: 'no_contract',
  not_linked: 'not_linked',
  offer_forwarded: 'offer_forwarded'
} as const;

export type RtaOfferStatus = typeof RtaOfferStatus[keyof typeof RtaOfferStatus];
export type RunCrmPullOperationInput = {
  crmIntegrationId: Scalars['ID']['input'];
  operation: CrmPullOperation;
};

export type SaveDraftOfferInput = {
  /** Allow additional signatories to be added before title transfer */
  addAdditionalSignatoriesLater?: InputMaybe<Scalars['Boolean']['input']>;
  /** For offers on referred listings - Information about the agents the offer should be sent to */
  agents?: InputMaybe<Array<OfferAgentInput>>;
  /** Agree to use of digital signatures on contract */
  agreeToUseOfDigitalSignatures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Offer amount in AUD (whole dollars) */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of Agent attributed to the offer */
  attributedAgentId?: InputMaybe<Scalars['String']['input']>;
  /** Buyer ID */
  buyerId: Scalars['ID']['input'];
  /** List of revision ids of conditions to add to offer. */
  conditionRevisions: Array<ConditionRevisionInput>;
  /** Conveyancer information (optional) */
  conveyancer?: InputMaybe<ConveyancerInformationInput>;
  /** Content of custom condition (optional) */
  customConditionContent?: InputMaybe<Scalars['String']['input']>;
  /** Purchase deposit amount */
  depositAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Purchase deposit selection */
  depositPercentage?: InputMaybe<DepositPercentage>;
  /** Expiry date (optional) */
  expiresAt?: InputMaybe<Scalars['ISODateString']['input']>;
  /** Finance declaration (optional) */
  finance?: InputMaybe<FinanceDeclarationInput>;
  /** Listing ID */
  listingId: Scalars['ID']['input'];
  /** For offers on referred listings - Information about the property the offer is for */
  property?: InputMaybe<OfferPropertyInput>;
  /** Settlement */
  settlement?: InputMaybe<OfferSettlementInput>;
  /** Signatories */
  signatories: Array<DraftOfferSignatoryInput>;
};

export type SaveVendorLeadDataInput = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  situation?: InputMaybe<Scalars['String']['input']>;
};

export type SaveVendorLeadInput = {
  data: SaveVendorLeadDataInput;
  source: VendorLeadSourceInput;
};

export type SendAnnouncementInput = {
  /** The agent this announcement is sent on behalf of */
  agentId: Scalars['String']['input'];
  /** Array of Propps Buyer IDs to be recipients of the announcement */
  buyerIds: Array<Scalars['String']['input']>;
  /** Supports 'sms' and 'email' as channels for announcement */
  channels: Array<Scalars['String']['input']>;
  /** The listing this announcement is tied to */
  listingId: Scalars['String']['input'];
  /** Announcement message body */
  message: Scalars['String']['input'];
  /** Array of CRMPropertyInterest IDs to be recipients of the announcement */
  propertyInterestIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendOfferAcknowledgementInput = {
  agentId: Scalars['ID']['input'];
  buyerId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  offerId: Scalars['ID']['input'];
};

export type SendOfferDetailsToRtaInput = {
  agencyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
};

export type SendProfileDomainVerificationEmailInput = {
  agentId: Scalars['ID']['input'];
  domainId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type SendPushNotificationToAgentInput = {
  agentId: Scalars['ID']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  dataId?: InputMaybe<Scalars['String']['input']>;
  messageDelaySeconds?: InputMaybe<Scalars['Int']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SetAgencyAgentClaimEmailTemplateInput = {
  id: Scalars['ID']['input'];
  template: AgentClaimEmailTemplateType;
};

export type SetAgentPersistedInteractionInput = {
  agentId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SetAgentProfileDataInput = {
  agency?: InputMaybe<AgentProfileAgencyInput>;
  background?: InputMaybe<AgentProfileBackgroundInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  highlightBusinessInLayout?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<AgentProfileLayoutInput>;
  links?: InputMaybe<Array<AgentProfileLinkInput>>;
  showCompanyDetails?: InputMaybe<Scalars['Boolean']['input']>;
  showEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showListings?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  socials?: InputMaybe<Array<AgentProfileSocialsInput>>;
};

export type SetAgentProfileInput = {
  agentId: Scalars['ID']['input'];
  data: SetAgentProfileDataInput;
};

export type SetAgentRoleInput = {
  agentId: Scalars['ID']['input'];
  role: AgentRole;
};

export type SetCampaignAutomationAgencyConfigurationInput = {
  agencyId: Scalars['ID']['input'];
  data: CampaignAutomationConfigurationInput;
  type?: InputMaybe<CampaignAutomationConfigurationType>;
};

export type SetCampaignAutomationAgentConfigurationInput = {
  agentId: Scalars['ID']['input'];
  data?: InputMaybe<CampaignAutomationConfigurationInput>;
  type?: InputMaybe<CampaignAutomationConfigurationType>;
};

export type SettleBillingGroupInvoicesInput = {
  consolidatedInvoiceId: Scalars['ID']['input'];
};

export type SetupSsoUserInput = {
  token: Scalars['String']['input'];
};

export type SkipIdentityVerificationForEntityInput = {
  /** Reason for skipping identity verification */
  reason: SkipIdentityVerificationReason;
  referenceId: Scalars['ID']['input'];
};

export const SkipIdentityVerificationReason = {
  international_documents: 'international_documents'
} as const;

export type SkipIdentityVerificationReason = typeof SkipIdentityVerificationReason[keyof typeof SkipIdentityVerificationReason];
export const SocialNetwork = {
  facebook: 'facebook',
  instagram: 'instagram',
  linkedin: 'linkedin',
  snapchat: 'snapchat',
  soundcloud: 'soundcloud',
  spotify: 'spotify',
  telegram: 'telegram',
  threads: 'threads',
  tiktok: 'tiktok',
  twitter: 'twitter',
  whatsapp: 'whatsapp',
  youtube: 'youtube'
} as const;

export type SocialNetwork = typeof SocialNetwork[keyof typeof SocialNetwork];
export type StartPhoneVerificationInput = {
  phone: Scalars['String']['input'];
};

export type StoreTemporaryReferrerListingDataInput = {
  appId: Scalars['String']['input'];
  foreignId: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};

export type SubmitAppraisalRequestInput = {
  address: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  preferredContactTime: Scalars['String']['input'];
};

export type SubmitGenericOfferInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  agentId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  conditions: GenericOfferConditions;
  deposit: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  settlement: Scalars['String']['input'];
};

export type SubmitOfferInput = {
  /** Allow additional signatories to be added before title transfer */
  addAdditionalSignatoriesLater: Scalars['Boolean']['input'];
  /** Additional comments from the buyer */
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  /** For offers on referred listings - Information about the agents the offer should be sent to */
  agents?: InputMaybe<Array<OfferAgentInput>>;
  /** Agree to use of digital signatures on contract */
  agreeToUseOfDigitalSignatures: Scalars['Boolean']['input'];
  /** Offer amount in AUD (whole dollars) */
  amount: Scalars['Int']['input'];
  /** Agent attributed to the offer (optional) */
  attributedAgentId?: InputMaybe<Scalars['String']['input']>;
  /** List of revision ids of conditions to add to offer. */
  conditionRevisions: Array<ConditionRevisionInput>;
  /** Conveyancer information (optional) */
  conveyancer?: InputMaybe<ConveyancerInformationInput>;
  /** Content of custom condition (optional) */
  customConditionContent?: InputMaybe<Scalars['String']['input']>;
  /** Purchase deposit amount */
  depositAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Purchase deposit selection */
  depositPercentage?: InputMaybe<DepositPercentage>;
  /** Expiry date (optional) */
  expiresAt?: InputMaybe<Scalars['ISODateString']['input']>;
  /** Finance declaration (optional) */
  finance?: InputMaybe<FinanceDeclarationInput>;
  /** Whether the offer to submit is intended to be binding. The offer will be rejected if the wrong type is submitted. */
  isBinding: Scalars['Boolean']['input'];
  listingId: Scalars['ID']['input'];
  /** For offers on referred listings - Information about the property the offer is for */
  property?: InputMaybe<OfferPropertyInput>;
  /** Settlement */
  settlement: OfferSettlementInput;
  /** Signatories */
  signatories: Array<OfferSignatoryInput>;
  /** ID of offer to replace, must be provided when updating an offer. */
  supersedes?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmitQuickOfferBuyerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SubmitQuickOfferConditionsInput = {
  other?: InputMaybe<Scalars['String']['input']>;
  subjectToBuildingInspection: Scalars['Boolean']['input'];
  subjectToFinance: Scalars['Boolean']['input'];
  subjectToPestInspection: Scalars['Boolean']['input'];
};

export type SubmitQuickOfferInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['String']['input'];
  buyer: SubmitQuickOfferBuyerInput;
  conditions: SubmitQuickOfferConditionsInput;
  listing: SubmitQuickOfferListingInput;
  privacyPolicyRevisionId: Scalars['String']['input'];
  purchaseDeposit: SubmitQuickOfferPurchaseDepositInput;
  settlement: SubmitQuickOfferSettlementInput;
  termsAndConditionsRevisionId: Scalars['String']['input'];
};

export type SubmitQuickOfferListingInput = {
  id: Scalars['ID']['input'];
  state: SubmitQuickOfferListingState;
};

export const SubmitQuickOfferListingState = {
  ACT: 'ACT',
  NSW: 'NSW',
  NT: 'NT',
  QLD: 'QLD',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA'
} as const;

export type SubmitQuickOfferListingState = typeof SubmitQuickOfferListingState[keyof typeof SubmitQuickOfferListingState];
export type SubmitQuickOfferPurchaseDepositInput = {
  type: SubmitQuickOfferPurchaseDepositType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export const SubmitQuickOfferPurchaseDepositType = {
  amount: 'amount',
  percentage: 'percentage',
  tbd: 'tbd'
} as const;

export type SubmitQuickOfferPurchaseDepositType = typeof SubmitQuickOfferPurchaseDepositType[keyof typeof SubmitQuickOfferPurchaseDepositType];
export type SubmitQuickOfferSettlementInput = {
  type: SubmitQuickOfferSettlementType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export const SubmitQuickOfferSettlementType = {
  date: 'date',
  days: 'days',
  tbd: 'tbd'
} as const;

export type SubmitQuickOfferSettlementType = typeof SubmitQuickOfferSettlementType[keyof typeof SubmitQuickOfferSettlementType];
export const SubmittedOfferType = {
  binding: 'binding',
  nonbinding: 'nonbinding',
  quick: 'quick'
} as const;

export type SubmittedOfferType = typeof SubmittedOfferType[keyof typeof SubmittedOfferType];
export const TemplateInheritance = {
  agency: 'agency',
  agent: 'agent'
} as const;

export type TemplateInheritance = typeof TemplateInheritance[keyof typeof TemplateInheritance];
export type TermsRevisionInput = {
  id: Scalars['String']['input'];
  line: Scalars['String']['input'];
};

export type ToggleAgencyAcceptOffersWhileUnderOfferInput = {
  agencyId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ToggleAgencyDeactivatedInput = {
  agencyId: Scalars['ID']['input'];
  deactivated: Scalars['Boolean']['input'];
};

export type ToggleAgencyListingResolutionInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type ToggleAgencyNotificationsEnabledInput = {
  agencyId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ToggleAgencyOnboardedInput = {
  agencyId: Scalars['ID']['input'];
  onboarded: Scalars['Boolean']['input'];
};

export type ToggleAgencyQuickOffersForNewListings = {
  agencyId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ToggleAgencyShouldSendClaimEmailInput = {
  dispatchToExistingAgents?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

/** Toggle agency wide offer boost (admin use) */
export type ToggleAgencyWideOfferBoostInput = {
  agencyId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ToggleAgentDeactivatedInput = {
  agentId: Scalars['ID']['input'];
  deactivated: Scalars['Boolean']['input'];
};

export type ToggleBybReferralsInput = {
  agencyId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ToggleCrmIntegrationEnabledInput = {
  crmIntegrationId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ToggleConveyancingReferralsInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type ToggleListingViewDocumentsInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type ToggleProfileIndexingInput = {
  agentId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type TrackProfileSessionInput = {
  event: ProfileSessionEventInput;
  id: Scalars['ID']['input'];
};

export type UnlinkAgentUserInput = {
  agentId: Scalars['ID']['input'];
};

export type UnlinkBuyerInput = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Unlock offer boost */
export type UnlockOfferBoostInput = {
  listingId: Scalars['String']['input'];
};

export type UpdateAgencyAssignedFeaturesInput = {
  flags: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateAgencyBillingAccountInput = {
  agencyId: Scalars['String']['input'];
  representative: AgencyBillingAccountRepresentativeInput;
};

/** updateAgency mutation input */
export type UpdateAgencyInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Skip Agency OfferBoost automation  */
export type UpdateAgencyOfferBoostAutomationInput = {
  agencyId: Scalars['String']['input'];
  skipBilling: Scalars['Boolean']['input'];
  skipUnlockNewListings: Scalars['Boolean']['input'];
};

/** Update agency wide offer boost settings */
export type UpdateAgencyOfferBoostSettingsInput = {
  agencyId: Scalars['String']['input'];
  includeAuctionListings: Scalars['Boolean']['input'];
  includeCommercialListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAgencyProfileInput = {
  agencyId: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgentCorrelationOnIntegrationInput = {
  crmId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  proppsId: Scalars['String']['input'];
};

/** updateAgent mutation input */
export type UpdateAgentInput = {
  detailsVerified?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgentNotificationPreferencesInput = {
  hash: Scalars['String']['input'];
  preferences: UpdateAgentNotificationPreferencesPreferencesInput;
};

export type UpdateAgentNotificationPreferencesPreferencesInput = {
  buyer_registration_updates?: InputMaybe<Scalars['Boolean']['input']>;
  campaign_updates?: InputMaybe<Scalars['Boolean']['input']>;
  claim_account_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  offerboost_campaign_tips?: InputMaybe<Scalars['Boolean']['input']>;
  product_announcements?: InputMaybe<Scalars['Boolean']['input']>;
  weekly_summary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAuctionRegistrationPaddleNoInput = {
  buyerId: Scalars['ID']['input'];
  listingId: Scalars['ID']['input'];
  paddleNo?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAuctionRegistrationProxyForInput = {
  arrayId: Scalars['ID']['input'];
  hash: Scalars['String']['input'];
  proxyFor: ProxyForInput;
  registrationId: Scalars['ID']['input'];
};

export type UpdateBuyerHasOptedOutOfIdvInput = {
  hasOptedOutOfIdv: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateBuyerNotificationPreferencesInput = {
  hash: Scalars['String']['input'];
  preferences: UpdateBuyerNotificationPreferencesPreferencesInput;
};

export type UpdateBuyerNotificationPreferencesPreferencesInput = {
  listing_announcements?: InputMaybe<Scalars['Boolean']['input']>;
  new_offer_notification?: InputMaybe<Scalars['Boolean']['input']>;
  transactional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateBuyerProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmIntegrationListingCorrelation = {
  crmId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  periodicSyncEnabled: Scalars['Boolean']['input'];
};

export type UpdateConsolidatedInvoiceStatusInput = {
  consolidatedInvoiceId: Scalars['ID']['input'];
  status: ConsolidatedInvoiceStatus;
};

export type UpdateCountdownTimerCampaignAutomationInput = {
  data?: InputMaybe<CampaignAutomationCountdownTimerConfigurationInput>;
  listingId: Scalars['ID']['input'];
};

export type UpdateCountdownTimerSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  expiry?: InputMaybe<Scalars['ISODateString']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['String']['input'];
  notifyBuyersBeforeExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  pauseListingOnExpiry?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCrmIntegrationAgentFilterInput = {
  filterAgents?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterAgentsExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
};

export type UpdateCrmIntegrationListingUrlTemplateInput = {
  id: Scalars['ID']['input'];
  listingUrlTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmIntegrationPullAuctionListingsInput = {
  id: Scalars['ID']['input'];
  pullAuctionListings: Scalars['Boolean']['input'];
};

export type UpdateCrmIntegrationPullCommercialListingsInput = {
  id: Scalars['ID']['input'];
  pullCommercialListings: Scalars['Boolean']['input'];
};

export type UpdateCrmIntegrationPullPrivateTreatyListingsInput = {
  id: Scalars['ID']['input'];
  pullPrivateTreatyListings: Scalars['Boolean']['input'];
};

export type UpdateCrmIntegrationPullResidentialListingsInput = {
  id: Scalars['ID']['input'];
  pullResidentialListings: Scalars['Boolean']['input'];
};

export type UpdateCrmIntegrationPushEnabledInput = {
  id: Scalars['ID']['input'];
  pushEnabled: Scalars['Boolean']['input'];
};

export type UpdateDeveloperAppDomainAllowListInput = {
  appId: Scalars['String']['input'];
  domains: Array<Scalars['String']['input']>;
};

export type UpdateDeveloperAppNameInput = {
  appId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Update listing accept conditional offers settings */
export type UpdateListingAcceptConditionalOffersSettingsInput = {
  acceptConditionalOffers: ListingAcceptConditionalOffersInput;
  id: Scalars['ID']['input'];
};

export type UpdateListingContractInput = {
  contract: FileUploadInput;
  id: Scalars['ID']['input'];
};

export type UpdateListingDepositRequiredSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateListingDocumentVisibilityInput = {
  documentRef: ListingDocumentRef;
  id: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
};

export type UpdateListingExposeCompetitionSettingsInput = {
  id: Scalars['ID']['input'];
  state: ListingExposeCompetitionState;
};

/** Update listing expose insights offers settings */
export type UpdateListingExposeInsightsSettingsInput = {
  exposeInsights: ListingExposeInsightsInput;
  id: Scalars['ID']['input'];
};

export type UpdateListingHoldingDepositSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  listingId: Scalars['ID']['input'];
  trustAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateListingInput = {
  acceptedOfferType?: InputMaybe<OfferType>;
  id: Scalars['ID']['input'];
  priceIndication?: InputMaybe<ListingPriceIndicationInput>;
  property?: InputMaybe<PropertyInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ListingSourceInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateListingLink = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateListingLinkInput = {
  link: UpdateListingLink;
  listingId: Scalars['ID']['input'];
};

/** Update new offer notification settings */
export type UpdateListingNewOfferNotificationsSettingsInput = {
  id: Scalars['ID']['input'];
  newOfferNotifications: ListingNewOfferNotificationsInput;
};

/** Update offer boost */
export type UpdateListingOfferBoostInput = {
  id: Scalars['String']['input'];
  offerBoost: ListingOfferBoostInput;
};

export type UpdateListingPrepareToBuySettingsInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateListingSharedCampaignRecommendationInput = {
  listingId: Scalars['ID']['input'];
};

export type UpdateListingStatusInput = {
  listingId: Scalars['ID']['input'];
  status: ListingStatus;
};

export type UpdateListingVendorInput = {
  listingId: Scalars['String']['input'];
  /** @deprecated see: vendors */
  vendor?: InputMaybe<VendorProfileInput>;
  vendors?: InputMaybe<Array<VendorProfileInput>>;
};

export type UpdateNewOfferNotificationsCampaignAutomationInput = {
  data?: InputMaybe<CampaignAutomationNewOfferNotificationsConfigurationInput>;
  listingId: Scalars['ID']['input'];
};

export type UpdateNfcCardDesignInput = {
  backLogoOffsetY?: InputMaybe<Scalars['Int']['input']>;
  backLogoUrl: Scalars['String']['input'];
  backgroundColor: Scalars['String']['input'];
  emailFontSize?: InputMaybe<Scalars['Int']['input']>;
  frontLogoOffsetY?: InputMaybe<Scalars['Int']['input']>;
  frontLogoUrl: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOfferBoostAgentListInput = {
  agencyId: Scalars['String']['input'];
  agentConfigs: Array<OfferBoostAgentConfig>;
};

export type UpdateOfferHoldingDepositStatusInput = {
  offerId: Scalars['ID']['input'];
  status: HoldingDepositStatus;
};

export type UpdateOfferRequestOfferInput = {
  /** Offer amount in AUD (whole dollars) */
  amount: Scalars['Int']['input'];
  /** List of revision ids of conditions to add to offer. */
  conditionRevisions: Array<ConditionRevisionInput>;
  /** Conveyancer information (optional) */
  conveyancer?: InputMaybe<ConveyancerInformationInput>;
  /** Content of custom condition (optional) */
  customConditionContent?: InputMaybe<Scalars['String']['input']>;
  /** Purchase deposit amount */
  depositAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Purchase deposit selection */
  depositPercentage?: InputMaybe<DepositPercentage>;
  /** Expiry date (optional) */
  expiresAt?: InputMaybe<Scalars['ISODateString']['input']>;
  /** Finance declaration (optional) */
  finance?: InputMaybe<FinanceDeclarationInput>;
  /** Settlement */
  settlement: OfferSettlementInput;
};

export type UpdateOffersMailingListInput = {
  agencyId: Scalars['ID']['input'];
  offersMailingList: Array<Scalars['String']['input']>;
};

export type UpdatePolicyPermissionsInput = {
  permissions: Array<PermissionStateInput>;
  policyId: Scalars['String']['input'];
};

export type UpdateProfileSessionInput = {
  data: ProfileSessionDataInput;
  id: Scalars['ID']['input'];
};

export type UpdateQrCodeMailingListInput = {
  agencyId: Scalars['ID']['input'];
  qrCodeMailingList: Array<Scalars['String']['input']>;
};

export type UpdateUserProfileInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type UpdateVendorLeadConfigAdditionalRecipientsInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorLeadConfigDataInput = {
  additionalRecipients: Array<UpdateVendorLeadConfigAdditionalRecipientsInput>;
  dispatchToListingAgents: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type UpdateVendorLeadConfigEntityInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVendorLeadConfigInput = {
  data: UpdateVendorLeadConfigDataInput;
  entity: UpdateVendorLeadConfigEntityInput;
};

export type UpdateWebhookSourcesInput = {
  appId: Scalars['String']['input'];
  sources: Array<WebhookEventSourceInput>;
  webhookId: Scalars['ID']['input'];
};

export type UploadAgentProfileImageInput = {
  contentType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  upload: FileUploadInput;
};

export type UploadAssetInput = {
  assetType: UploadAssetType;
  entityId: Scalars['ID']['input'];
  metadata: AssetUploadMetadata;
  upload: FileUploadInput;
};

export const UploadAssetType = {
  document: 'document',
  logo: 'logo'
} as const;

export type UploadAssetType = typeof UploadAssetType[keyof typeof UploadAssetType];
export type UserProfileInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type VendorInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export const VendorLeadSituation = {
  future: 'future',
  listed: 'listed',
  no: 'no',
  noowner: 'noowner',
  soon: 'soon'
} as const;

export type VendorLeadSituation = typeof VendorLeadSituation[keyof typeof VendorLeadSituation];
export type VendorLeadSourceInput = {
  buyerId: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
};

export type VendorProfileInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type VerifyProfileDomainInput = {
  domainId: Scalars['ID']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEventFiltersInput = {
  agencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  appIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listingIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WebhookEventSourceInput = {
  event: Scalars['String']['input'];
  omitFields?: InputMaybe<Array<Scalars['String']['input']>>;
  pickFields?: InputMaybe<Array<Scalars['String']['input']>>;
  topic: Scalars['String']['input'];
};

export type WithdrawOfferInput = {
  id: Scalars['ID']['input'];
};

export type CreateNewProfileAgencyInput = {
  country: Scalars['CountryCode']['input'];
  industry: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GetDeveloperAppQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDeveloperAppQuery = { app: { __typename?: 'DeveloperApp', id: string, automount: boolean | null } | null };

export type GetListingByUrlQueryVariables = Exact<{
  appId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
}>;


export type GetListingByUrlQuery = { app: { __typename?: 'DeveloperApp', listing: { __typename?: 'Listing', id: string, offerButtonLabel: string, published: boolean, shouldShowButtonOnWebsite: boolean, source: { __typename?: 'ListingSource', appId: string, foreignId: string } } | null } | null };

export type DeveloperAppListingQueryVariables = Exact<{
  developerAppId: Scalars['ID']['input'];
  foreignId: Scalars['ID']['input'];
}>;


export type DeveloperAppListingQuery = { developerApp: { __typename?: 'DeveloperApp', listing: { __typename?: 'Listing', id: string, offerButtonLabel: string, published: boolean, shouldShowButtonOnWebsite: boolean, source: { __typename?: 'ListingSource', appId: string, foreignId: string } } | null } | null };

export type ListingQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type ListingQuery = { listing: { __typename?: 'Listing', id: string, offerButtonLabel: string, published: boolean, shouldShowButtonOnWebsite: boolean, source: { __typename?: 'ListingSource', appId: string, foreignId: string } } | null };

export type Script_ListingFragment = { __typename?: 'Listing', id: string, offerButtonLabel: string, published: boolean, shouldShowButtonOnWebsite: boolean, source: { __typename?: 'ListingSource', appId: string, foreignId: string } };

export const Script_ListingFragmentDoc = gql`
    fragment Script_Listing on Listing {
  id
  offerButtonLabel
  published
  shouldShowButtonOnWebsite
  source {
    appId
    foreignId
  }
}
    `;
export const GetDeveloperAppDocument = gql`
    query GetDeveloperApp($id: ID!) {
  app: developerApp(id: $id) {
    id
    automount
  }
}
    `;
export const GetListingByUrlDocument = gql`
    query GetListingByUrl($appId: ID!, $url: String!) {
  app: developerApp(id: $appId) {
    listing(url: $url) {
      ...Script_Listing
    }
  }
}
    ${Script_ListingFragmentDoc}`;
export const DeveloperAppListingQueryDocument = gql`
    query DeveloperAppListingQuery($developerAppId: ID!, $foreignId: ID!) {
  developerApp(id: $developerAppId) {
    listing(foreignId: $foreignId) {
      ...Script_Listing
    }
  }
}
    ${Script_ListingFragmentDoc}`;
export const ListingQueryDocument = gql`
    query ListingQuery($listingId: ID!) {
  listing(id: $listingId) {
    ...Script_Listing
  }
}
    ${Script_ListingFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetDeveloperApp(variables: GetDeveloperAppQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDeveloperAppQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDeveloperAppQuery>(GetDeveloperAppDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetDeveloperApp', 'query');
    },
    GetListingByUrl(variables: GetListingByUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetListingByUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListingByUrlQuery>(GetListingByUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetListingByUrl', 'query');
    },
    DeveloperAppListingQuery(variables: DeveloperAppListingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeveloperAppListingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeveloperAppListingQuery>(DeveloperAppListingQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeveloperAppListingQuery', 'query');
    },
    ListingQuery(variables: ListingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ListingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListingQuery>(ListingQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ListingQuery', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;